import React, { useState,useEffect,useMemo,useRef } from "react";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Marquee from '../components/Marquee.jsx';
import IncrementTansition3 from '../components/IncrementTansition3.jsx';
import IncrementTransitionWrapper from '../components/IncrementTransitionWrapper.jsx';
import FAQS from '../components/FAQ.jsx';
import Header from '../components/Header.jsx'
import Footer from '../components/Footer.jsx'
import { toast } from "react-toastify";
import axiosInstance from "../axiosInstance.js"
import { baseUrl, SUCCESS, TRUSTEDBY_COUNT } from "../config/configuration.js";
import { HashLink } from "react-router-hash-link";
import { motion, AnimatePresence } from "framer-motion"
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react"
import { Pagination, Navigation, Autoplay } from "swiper/modules"
import moment from 'moment'
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"
import { useLocation } from 'react-router-dom';

import {
  FaWifi,
  FaTv,
  FaUtensils,
  FaTree,
  FaUmbrellaBeach,
  FaBuilding,
  FaTshirt,
  FaSwimmingPool,
  FaParking,
  FaFire,
  FaSnowflake,
  FaDumbbell,
  FaChevronLeft,
  FaChevronRight
} from "react-icons/fa";

import { MdDeck } from "react-icons/md";
import axios from "axios";

export default function Home() {

  const [email,setEmail]=useState("");
  const [phone,setPhone]=useState("");
  const [name,setName]=useState("");
  const [query,setQuery]=useState("");
  const [checkInDate,setCheckInDate]=useState(null);
  const [checkOutDate,setCheckOutDate]=useState(null);
  const [propertyLocation,setPropertyLocation]=useState("");
  const [showPicker, setShowPicker] = useState(false);
  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  const intervalRef = useRef(null)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)
  const [properties ,setProperties]=useState([])
  const [locations ,setLocations]=useState([])
  const [amenities ,setAmenities]=useState([])
  const [stats ,setStats]=useState({})
  const [propertyImages ,setPropertyImages]=useState([])
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [videoLink, setVideoLink] = useState('');
  const [thumbnailLink, setThunbnailLink] = useState('');
  const [selectedTestimonial, setSelectedTestimonial] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [testimonials, setTestimonials] = useState([]);

  const videoRef = useRef(null);

  const location = useLocation();
  const navigate = useNavigate();

  const amenityIconMap = {
      "High-Speed WiFi": <FaWifi />,
      "Smart TV": <FaTv />,
      "Gourmet Kitchen": <FaUtensils />,
      "Garden": <FaTree />,
      "Patio": <MdDeck />,
      "Terrace": <FaUmbrellaBeach />,
      "Balcony": <FaBuilding />,
      "Laundry": <FaTshirt />,
      "Private Pool": <FaSwimmingPool />,
      "Secure Parking": <FaParking />,
      "Fireplace": <FaFire />,
      "BBQ Area": <FaFire />,
      "Central AC": <FaSnowflake />,
      "Gym": <FaDumbbell />,
      "Cafe"  : <FaUtensils />
  };

  const handleVideoClick = () => {
    if (isPlaying) {
      videoRef.current?.pause();
      setIsPlaying(false);
    } else {
      videoRef.current?.play();
      setIsPlaying(true);
    }
  };


  

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);




  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    getPropertiesDataCall();
    getLocationDataCall();
    getConfigurationSettingsCall();
    getGuestTestimonialsCall();
    getGalleryImagesCall();
    setVideoLink("https://res.cloudinary.com/dp3w8apmx/video/upload/v1778769495/guestexperice_video_wf4mg6.mp4")
    setThunbnailLink("https://res.cloudinary.com/dp3w8apmx/image/upload/v1778834609/bg-hero_mu7df7.jpg")
  }, []);


  const getPropertiesDataCall=async()=>{
    
      try {
        const response = await axios.get(`${baseUrl}property/all`,{
            headers: {"Content-Type":"application/json" }})

        if (response.status === 200) {

          let result = response?.data?.data?.filter((item)=>(item?.show && !item?.delete))

          setProperties(result)


        }
      
     
      } catch (err) {

       console.log("errr properrty get",err)
 
      }

    
  }

  const getLocationDataCall=async()=>{
    
      try {
        const response = await axios.get(`${baseUrl}location/get`,{
            headers: {"Content-Type":"application/json" }})

        if (response.status === 200) {

          let result = response?.data?.data?.filter((item)=>(item?.show))
          setLocations(result)

        }
      
     
      } catch (err) {

       console.log("errr properrty get",err)
 
      }

    
  }

  const getConfigurationSettingsCall=async()=>{
    
      try {
        const response = await axios.get(`${baseUrl}configuration/get`,{
            headers: {"Content-Type":"application/json" }})

        if (response.status === 200) {

          let result = response?.data?.data?.[0]?.amenities
          let result2 = response?.data?.data?.[0]?.stats
          setAmenities(result)
          setStats(result2)

        }
      
     
      } catch (err) {

       console.log("errr properrty get",err)
 
      }

    
  }

  const getGuestTestimonialsCall=async()=>{
    
      try {
        const response = await axios.get(`${baseUrl}testimonial/get?type=guest`,{
            headers: {"Content-Type":"application/json" }})

        if (response.status === 200) {

          let result = response?.data?.data
          setTestimonials(result)

        }
      
     
      } catch (err) {

       console.log("errr properrty get",err)
 
      }

    
  }

  const getGalleryImagesCall=async()=>{
    
      try {

        const response = await axios.get(`${baseUrl}image/all?type=gallery`,{
            headers: {"Content-Type":"application/json" }})

        if (response.status === 200) {

          let result = response?.data?.data?.filter((item)=>(item?.show))
          setPropertyImages(result)

        }
      
     
      } catch (err) {

       console.log("errr properrty get",err)
 
      }

    
  }

  const locationsData = useMemo(() => {
    return locations;
  }, [locations]);


  const handlePropertyBook =async(e,property)=>{
    e.preventDefault();
    navigate(`/property/view/${property?._id}`, { state: {flow : "book",property : property}  });
    
  }

  const handlePropertyClick =async(e,property)=>{
    e.preventDefault();
    navigate(`/property/view/${property?._id}`, { state: {flow : "view",property : property}  });

      
  }

  const openModal = (testimonial) => {
    setSelectedTestimonial(testimonial);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedTestimonial(null);
  };

  function PropertyCard({ property }) {
    const [hovered, setHovered] = useState(false);

    return (
      <div
        onClick={(e)=>{handlePropertyClick(e,property)}}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          ...zoomStyle2,
          background: "white",
          borderRadius: "8px",
          overflow: "hidden",
          boxShadow: hovered
            ? "0 12px 40px rgba(44,37,23,0.15)"
            : "0 2px 16px rgba(44,37,23,0.07)",
          transition: "0.3s",
          transform: hovered ? "translateY(-4px)" : "none",
          height: "520px",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <div
          style={{
            position: "relative",
            paddingTop: "65%",
            overflow: "hidden"
          }}
        >
          <img
            src={property.images?.[0]?.url}
            alt={property.title}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transform: hovered ? "scale(1.05)" : "scale(1)",
              transition: "0.5s"
            }}
          />
          <div
            style={{
              position: "absolute",
              top: "12px",
              left: "12px",
              display: "flex",    
              flexDirection: "row",  
              gap: "5px",            
              zIndex: 10,            
              width: "max-content"   
            }}
          >
            {property.tag && (
              <div
                style={{
                  background: "var(--secondary)",
                  color: "white",
                  padding: "4px 10px",
                  borderRadius: "3px",
                  fontSize: "11px",
                  fontWeight: "700",
                  whiteSpace: "nowrap" 
                }}
              >
                {property.tag}
              </div>
            )}

            {property.propertyType && (
              <div
                style={{
                  background: "var(--secondary)",
                  color: "white",
                  padding: "4px 10px",
                  borderRadius: "3px",
                  fontSize: "11px",
                  fontWeight: "700",
                  whiteSpace: "nowrap"
                }}
              >
                {property.propertyType}
              </div>
            )}
          </div>
         
          {property.rating && (
            <div
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                background: "var(--secondary)",
                color: "white",
                padding: "4px 10px",
                borderRadius: "3px",
                fontSize: "11px",
                fontWeight: "700"
              }}
            >
              <i className="fa fa-star"></i> {"\u0000"} {"\u0000"}{property.rating}
            </div>
          )}

          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              background:
                "linear-gradient(to top, rgba(0,0,0,0.8), transparent)",
              padding: "10px 10px 10px",
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap"
            }}
          >
            {[
              {
                icon: <i className="fa fa-bed"></i>,
                label: `${property.spaceDetails.bedrooms} Rooms`
              },
              {
                icon: <i className="fa fa-bath"></i>,
                label: `${property.spaceDetails.bathrooms} Bathrooms`
              },
              {
                icon: <i className="fa fa-users"></i>,
                label: `${property.spaceDetails.guests} Guests`
              },
              {
                icon: <i className="fa fa-ruler-combined"></i>,
                label: `${property.spaceDetails.size} Sq.Ft`
              }
            ].map((item, i) => (
              <span
                key={i}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                  color: "white",
                  fontSize: "10px"
                }}
              >
                {item.icon}
                <span>{item.label}</span>
              </span>
            ))}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            padding: "16px"
          }}
        >
          <div
            style={{
              fontSize: "15px",
              fontWeight: "600",
              marginBottom: "4px"
            }}
          >
            {property.title}
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              fontSize: "11px",
              color: "var(--secondary)",
              marginBottom: "10px"
            }}
          >
            <i className="fa fa-map-marker-alt"></i>{" "}
            {property.locality},{" "}
            {locations.find((loc) => loc.value === property.location)?.label}
          </div>

          <div style={{ marginBottom: "10px" }}>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px"
              }}
            >
              {property.amenities?.slice(0, 9).map((amenity, i) => {
                const icon = amenityIconMap[amenity]
                if (!icon) return null;

                return (
                  <span
                    key={i}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      fontSize: "12px",
                      background: "#f6f3ee",
                      padding: "4px 8px",
                      borderRadius: "6px"
                    }}
                  >
                    {icon}
                    {amenity}
                  </span>
                );
              })}
            </div>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "auto",
              paddingTop: "10px",
              paddingBottom: "10px"
            }}
          >
            <div>
              <span style={{ fontSize: "12px" }}>From </span>
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "700",
                  color: "var(--secondary)"
                }}
              >
                ₹{property.price.toLocaleString()}
              </span>
              <span style={{ fontSize: "12px" }}> / Night</span>

              <div style={{ fontSize: "10px", color: "#aaa" }}>
                { property?.isTaxable ? "( Excl. Taxes & Charges )" : "( Inclusive of Taxes )"}

              </div>
            </div>

            <button
              style={{
                padding: "9px 15px",
                border: "1.5px solid #756534",
                background: "transparent",
                color: "var(--secondary)",
                borderRadius: "3px",
                fontSize: "12px",
                fontWeight: "700",
                cursor: "pointer"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "var(--secondary)";
                e.currentTarget.style.color = "white";
              }}
              onClick={(e) => {
                e.stopPropagation(); 
                handlePropertyBook(e, property);
              }}            
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
                e.currentTarget.style.color = "var(--secondary)";
              }}
            >
              Enquire Now
            </button>
          </div>
        </div>
      </div>
    );
  }


  useEffect(() => {
    const element = document.documentElement;
    element.style.scrollBehavior = 'smooth';
    element.scrollTo(0, 0);


    let temp = moment.utc().add(5,"hours").add(30,'minutes').format("YYYY-MM-DD")
    let temp1 = moment.utc().add(2,"days").add(5,"hours").add(30,'minutes').format("YYYY-MM-DD")
    setCheckInDate(temp)
    setCheckOutDate(temp1)


  }, []);

  const resetFilters = () => {
       navigate('/');
  };

  useEffect(() => {
      if (propertyImages && propertyImages.length > 0) {
        intervalRef.current = setInterval(() => {
          setCurrentImageIndex((prev) => (prev + 1) % propertyImages.length)
        }, 4000)
        return () => clearInterval(intervalRef.current)
      }
  }, [propertyImages.length])


  const handleSearch=async(e)=>{
    e.preventDefault();
    localStorage.setItem("filters", JSON.stringify({
      propertyLocation,
      checkInDate,
      checkOutDate,
      adults,
      children
    }));
    navigate('/properties');

  }

  const handleLocationClick=async(e,location)=>{
    e.preventDefault();
    localStorage.setItem("filters", JSON.stringify({
      propertyLocation : location.value,
      checkInDate,
      checkOutDate,
      adults,
      children
    }));
    navigate('/properties');

  }

  const handleValidate = () => {
    let formIsValid = true;

    if (!name) {
      formIsValid = false;
      toast.error("Please Enter Your Name!!");
    }

    if (!email && !phone) {
      formIsValid = false;
      toast.error("Please Enter Either Your Email or Phone Number!");
    }

    if (email && !/\S+@\S+\.\S+/.test(email)) {
      formIsValid = false;
      toast.error("Please Enter a Valid Email Address!");
    }

    if (phone) {
      const digitsOnly = phone.replace(/\D/g, "");
      if (digitsOnly.length < 7 || digitsOnly.length > 15) {
        formIsValid = false;
        toast.error("Please Enter a Valid Phone Number!");
      }
    }

    if (!query) {
      formIsValid = false;
      toast.error("Please Enter Your Question !!");
    }

  
    return formIsValid;
  };


  const handleSubmit=async(e)=>{
    e.preventDefault();

    let formValid=handleValidate();

    if(formValid){

      let data={  
        'email': email,
        'phone': phone,
        'name': name,
        // 'orgName': orgName,
        'message': query,
      }

      try {
        const response = await axiosInstance.post(`${baseUrl}/query/add`, data,{
            headers: {"Content-Type":"application/json"}})
        if (response.status ===  SUCCESS) {
          setEmail("");
          setPhone("");
          setName("");
          // setOrgName("");
          setQuery("");
          toast.success("Thanks for Reaching out to Us. Our Team will Connect back to you Shortly !!");
          navigate("/")
        } 
      } catch (err) {
        console.log("Error",err)
        toast.error("Unable to Request your Query. Please Try Again Later !!");
      }
  
    } 
  }


  const zoomStyle = {
      transform: 'scale(0.9)',
      transformOrigin: 'top left', 
      width: '111.11%',
      display: 'block',
      top: 0,
      left: 0,
  };
  
  const zoomStyle2 = {
      transform: 'scale(0.9)',
      transformOrigin: 'top left', 
      width: '100%',
      display: 'block',
      top: 0,
      left: 0,
  };


  const zoomStyle3 = {
      transform: 'scale(0.9)',
      transformOrigin: 'top center', 
      width: '100%',
      display: 'block',
      top: 0,
      left: 0,
  };

  return (
    <>
      <Header/>
      <div>

        {/* Home Start */}

        <div className="container-fluid  py-5 mb-5 hero-header" id='home' style={zoomStyle}>
          <div className="container py-5">
            <div className="row justify-content-start py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-start introstart">
              <h2 className="fs-4 text-white mb-3 fw-normal animated slideInDown">
                Rooted in Excellence, Grown for the Extraordinary.

              </h2>
              <h1 className="display-4 text-white mb-4 fw-bold text-uppercase tracking-wide animated slideInDown">
                Sophisticated boutique living, crafted with Absolute Precision.
              </h1>
              <h2 className="fs-4 text-white mb-3 fw-normal animated slideInDown">
                Experience A New Era Of Bold Hospitality where iconic style meets seamless Boutique Luxury.
              </h2>
            </div>

            
          </div>
          <div className="qs-search-wrapper">
            <div className="qs-search-container">
              <div className="qs-search-flex-bar">
                
                <div className="qs-search-block">
                  <label className="qs-label"><i className="bi bi-search qs-search"></i>{"  "}Location</label>
                    {/* <input type="text" className="qs-input" placeholder="All" value={propertyLocation} onChange={(e)=>{setPropertyLocation(e.target.value)}} /> */}
                  <select 
                    className="qs-input" 
                    value={propertyLocation} 
                    onChange={(e) => setPropertyLocation(e.target.value)}
                    style={{ appearance: 'none' }}
                  >
                    <option key={""} value={"all"}>{"All"}</option>
                    {locationsData.map((loc, index) => (
                      <option key={index} value={loc.value}>
                        {loc.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="qs-divider"></div>

                <div className="qs-search-block">
                  <label className="qs-label">Check In</label>
                  <input type="date" className="qs-input" value={checkInDate} onChange={(e)=>{setCheckInDate(e.target.value)}} />
                </div>

                <div className="qs-divider"></div>

                <div className="qs-search-block">
                  <label className="qs-label">Check Out</label>
                  <input type="date" className="qs-input" value={checkOutDate} onChange={(e)=>{

                    const start = moment(checkInDate).startOf('day');
                    const end = moment(e.target.value).startOf('day');

                    console.log("start",start,end,end.isSameOrBefore(start, 'day'))

                    if (end.isSameOrBefore(start, 'day')) {
                        toast.error("Please select a Check Out date that follows your arrival.");
                      setCheckOutDate(moment(checkInDate).add(1, 'days').format("YYYY-MM-DD"));
                    } else {
                      setCheckOutDate(e.target.value)
                    }
                                    
                    
                    
                    }} />
                </div>

                <div className="qs-divider"></div>

                {/* <div className="qs-search-block">
                  <label className="qs-label">No Of Guests</label>
                    <input type="number" className="qs-input" placeholder="1" value={adults} onChange={(e)=>{
                      const value = parseInt(e.target.value);
                      setAdults(value < 1 || isNaN(value) ? 1 : value);
                      
                      }} />
                </div> */}
                <div className="qs-search-block" style={{ position: 'relative' }}>
                  <label className="qs-label">Guests</label>
            
                  <div 
                    className="qs-input guest-input-display" 
                    onClick={() => setShowPicker(!showPicker)}
                  >
                    {`Adult ${adults} and Child ${children}`}
                  </div>

                  {showPicker && (
                    <div className="qs-guest-picker shadow">
                      <div className="qs-guest-row">
                        <div>
                          <div className="qs-guest-title">Adults</div>
                          <small className="qs-guest-subtitle">12+</small>
                        </div>
                        <div className="qs-counter">
                          <button onClick={() => adults > 1 && setAdults(adults - 1)}>-</button>
                          <span>{adults}</span>
                          <button onClick={() => setAdults(adults + 1)}>+</button>
                        </div>
                      </div>

                      <div className="qs-guest-row">
                        <div>
                          <div className="qs-guest-title">Children</div>
                          <small className="qs-guest-subtitle">6-11</small>
                        </div>
                        <div className="qs-counter">
                          <button onClick={() => children > 0 && setChildren(children - 1)}>-</button>
                          <span>{children}</span>
                          <button onClick={() => setChildren(children + 1)}>+</button>
                        </div>
                      </div>

                      <button className="qs-done-btn" onClick={() => setShowPicker(false)}>
                        Done
                      </button>
                    </div>
                  )}
                </div>

                <button type="button" className="qs-search-btn" onClick={(e)=>{handleSearch(e)}}>
                  Search
                </button>
                
              </div>
            </div>
          </div>


        </div>
        </div>

        {/* Home End */}

        {/* About Start */}

        <div className="container-xxl py-5 p-5 padding-top-custom"   id='about'> 
          <div className="container">
            <div className="row g-5">
              <div className="col-lg-6 col-md-6 wow fadeInUp custom-ginie-div" data-wow-delay="0.02s">
                <div className="position-relative h-100 d-flex justify-content-center align-items-center">
                  <img
                    className="img-fluid custom-genie-mobile"
                    src={require('../assets/img/7.jpg')}
                    alt="About Us"
                    style={{ 
                      objectFit: "cover", 
                      maxHeight: "400px",
                      borderRadius : 20, 
                      width: "auto"      
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6  wow fadeInUp custom-text-about" data-wow-delay="0.3s">
                <h6 className="section-title bg-white text-start text-primary pe-3">
                  About Us
                </h6>
                <h1 className="mb-3">
                  Welcome to <span className="text-primary">Quercus Oak Stays</span>
                </h1>
                <p className="mb-4 text-justify">
                  Welcome to Quercus Oak Hospitality, where Timeless Elegance meets the Pinnacle of Boutique Service.
                  </p>
                <p className="mb-4 text-justify">
                  Established in 2021, we believe that true Luxury is found in the details—the strength of our Heritage and the warmth of our Personalized Care. 
                </p>

                <p className="mb-4 text-justify">
                  Our Portfolio of Boutique Properties offers a Rare, Immersive Experience for the Discerning Traveler. Leveraging a passion for Architectural beauty and Premium Service, we are redefining what it means to stay in style. From Tranquil Retreats to Urban Sanctuaries, our Commitment ensures an uncompromising standard of Excellence and World-Class Comfort.
                </p>
                <p className="mb-4 text-justify">
                Our Team is composed of Industry Visionaries, Service Artisans, and Hospitality Experts dedicated to crafting Exceptional Journeys. With a robust focus on Operational Precision and Guest Satisfaction, We are committed to elevating Hotel Expericence into an art form, giving you peace of mind and Unforgettable Memories.
                </p>
                <div className="row gy-2 gx-4 mb-4">
                  <div className="col-sm-6">
                    <p className="mb-0">
                      <i className="fa fa-arrow-right text-primary me-2" />
                      Vision for Premier Excellence
                    </p>
                  </div>
                  <div className="col-sm-6">
                    <p className="mb-0">
                      <i className="fa fa-arrow-right text-primary me-2" />
                      Curated Boutique Experiences
                    </p>
                  </div>
                  <div className="col-sm-6">
                    <p className="mb-0">
                      <i className="fa fa-arrow-right text-primary me-2" />
                      Unwavering Management Quality
                    </p>
                  </div>
                  <div className="col-sm-6">
                    <p className="mb-0">
                      <i className="fa fa-arrow-right text-primary me-2" />
                      Established Legacy Since 2021
                    </p>
                  </div>
                  
                </div>
          
              </div>
              <br />

            </div>
          </div>
        </div>

        {/* About End */}

        {/* Locations Start */}
        
        <div className="container-xxl py-5 padding-top-custom padding-bottom-custom" id="locations">
          <div className="container">
            <div className="text-center wow fadeInUp" data-wow-delay="0.02s">
              <h6 className="section-title bg-white text-center text-primary px-3">
                Locations
              </h6>
              <h1 className="mb-5">Our Premium Locations</h1>
            </div>

              <Swiper
                modules={[Pagination, Autoplay]}
                spaceBetween={20}
                slidesPerView={3}
                loop={true}
                pagination={{ clickable: true }}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                speed={1000}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  600: { slidesPerView: 2 },
                  1000: { slidesPerView: 3 },
                }}
              >

                {locationsData.map((loc, index) => (
                  <SwiperSlide key={`loc-${index}`}>
                    <div
                      style={{
                        borderRadius: 25,
                        boxShadow: hoveredIndex === index ? "0 12px 40px rgba(44,37,23,0.15)" : "none",
                        transition: "0.3s",
                        transform: hoveredIndex === index ? "translateY(-4px)" : "none",
                      }}
                      className="bg-white text-center border p-4 m-2"
                      onMouseEnter={() => setHoveredIndex(index)}
                      onClick={(e) => handleLocationClick(e, loc)}
                      onMouseLeave={() => setHoveredIndex(null)}
                    >
                      <div style={{ borderRadius: 25, overflow: "hidden", paddingBottom: 15, position: "relative" }}>
                        <img
                          src={loc.image}
                          alt={loc.label}
                          style={{ width: "100%", height: 200, objectFit: "cover" }}
                        />

                        {loc.upcomming && (
                          <span
                            style={{
                              position: "absolute",
                              top: 12,
                              left: 12,
                              backgroundColor: "var(--secondary)",
                              color: "#fff",
                              fontSize: "0.7rem",
                              fontWeight: 600,
                              padding: "4px 10px",
                              borderRadius: 20,
                              letterSpacing: "0.5px",
                              textTransform: "uppercase",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                            }}
                          >
                            Upcoming
                          </span>
                        )}
                      </div>

                      <h5 className="mb-2">{loc.label}</h5>
                      <p className="mb-2 fw-bold text-decoration-underline">
                        Premium Destination
                      </p>
                      <p className="mb-0 small text-muted">
                        {loc.upcomming
                          ? `${loc.label} is coming to Quercus Oak Stay — Something Extraordinary is on its way!`
                          : `Experience the Best of ${loc.label} with Quercus Oak Stay's Premium Properties.`
                        }
                      </p>
                    </div>

                    <div style={{ paddingBottom: 40 }}></div>
                  </SwiperSlide>
                ))}
              
              </Swiper>

          </div>
        </div>

        {/* Locations End */}

        {/* Properties Start */}
        
        <div className="container-xxl py-5 padding-top-custom padding-bottom-custom" id="properties">
          <div className="container">
            <div className="text-center wow fadeInUp" data-wow-delay="0.02s">
              <h6 className="section-title bg-white text-center text-primary px-3">
                Properties
              </h6>
              <h1 className="mb-5">Our Featured Properties</h1>
            </div>
            
              
                {properties?.length ? (

                  <div className="text-center mt-5 wow fadeInUp" data-wow-delay="0.1s">
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: isMobile
                          ? "1fr"
                          : "repeat(auto-fill, minmax(280px, 1fr))",
                        gap: "20px",
                        justifyContent: "center",
                        margin: "0 auto",
                        maxWidth: isMobile ? "100%" : "1200px",
                      }}
                      className="wow fadeInUp" data-wow-delay="0.02s"
                      >
                        {

                          properties?.filter((item)=>(item.featured)).map((p) => (
                            <PropertyCard key={p.id} property={p} />
                          ))
                        }

                    </div>
                    <div className="text-center mt-5">
                      <p className="mb-3">Explore our full collection of premium stays</p>
                      <button
                          onClick={() => {

                            localStorage.removeItem('filters')
                            navigate('/properties')

                          }} 
                          style={{
                              padding: "12px 30px",
                              borderRadius: "50px",
                              border: "2px solid #756534",
                              background: "transparent",
                              color: "var(--secondary)",
                              fontWeight: "600",
                              transition: "0.3s",
                              cursor: "pointer"
                          }}
                          onMouseOver={(e) => {
                              e.target.style.background = "var(--secondary)";
                              e.target.style.color = "#fff";
                          }}
                          onMouseOut={(e) => {
                              e.target.style.background = "transparent";
                              e.target.style.color = "var(--secondary)";
                          }}
                      >
                          View All Properties
                      </button>
                    </div>
                  </div>

                ) : (

                  <div
                        style={{
                          gridColumn: "1 / -1",
                          textAlign: "center",
                          padding: "60px 20px",
                        }}
                      >
                        <h4 style={{ marginBottom: 10 }}>No Properties Found</h4>
                        <p style={{ color: "#888" }}>
                          No Properties Found
                        </p>

                        <button
                          onClick={resetFilters}
                          style={{
                            marginTop: 15,
                            padding: "8px 16px",
                            borderRadius: 8,
                            border: "none",
                            background: "var(--secondary)",
                            color: "#fff",
                            cursor: "pointer"
                          }}
                        >
                          Refresh
                        </button>
                  </div>
    
            )}
          
          </div>
        </div>

        {/* Properties End */}

        {/*Guest Experience Start */}

        <div className="container-xxl py-5 padding-top-custom padding-bottom-custom" id="experience">
          <div className="container">
            <div className="text-center wow fadeInUp" data-wow-delay="0.01s">
              <h6 className="section-title bg-white text-center text-primary px-3">
                The Quercus Experience
              </h6>
              <h1 className="mb-2">Where Every Stay Tells a Story</h1>
              <p className="text-muted mx-auto" style={{ maxWidth: 520, fontSize: 15 }}>
                We don't just Offer Properties — We Craft Journeys rooted in Warmth,
                Precision, and a deep love for the Extraordinary.
              </p>
            </div>
            <div className="row g-5 align-items-center">
              <div className="col-12 col-lg-6 wow fadeInLeft" data-wow-delay="0.01s">
                <div
                  style={{
                    width: 48,
                    height: 4,
                    background: "var(--secondary)",
                    borderRadius: 2,
                    marginBottom: 20,
                  }}
                />

                <h2 className="fw-bold mb-3" style={{ lineHeight: 1.35 }}>
                  Rooted in Care,<br />
                  <span style={{ color: "var(--secondary)" }}>Grown for the Extraordinary</span>
                </h2>

                <p className="text-muted mb-3" style={{ fontSize: "clamp(14px, 4vw, 14.5px)", lineHeight: 1.8 }}>
                  At Quercus Oak Stays, Luxury isn't measured in thread Counts or Marble
                  Floors — It lives in the unhurried morning chai on a Himalayan terrace,
                  the crackle of a Bonfire under open skies, and a Team that remembers
                  your Name before you Arrive.
                </p>

                <p className="text-muted mb-4" style={{ fontSize: "clamp(14px, 4vw, 14.5px)", lineHeight: 1.8 }}>
                  From Our Very First Boutique Stay in 2021, We've built every Property
                  around one Question: <em>"What would make a Guest never want to Leave?"</em>
                </p>

                <div
                  className="d-flex flex-wrap gap-2 gap-sm-3 mb-4"
                  style={{ borderTop: "1px solid #e8e0d5", paddingTop: 20 }}
                >
                  {Object.values(stats?.customerInsights?.others || {}).map((s, i) => (
                    <div
                      key={i}
                      className="flex-fill flex-sm-grow-0"
                      style={{
                        textAlign: "center",
                        minWidth: 100,
                        padding: "10px 16px",
                        borderRadius: 10,
                        background: "#fff",
                        boxShadow: "0 2px 12px rgba(117,101,52,0.08)",
                      }}
                    >
                      <div
                        style={{
                          fontSize: 20,
                          fontWeight: 600,
                          color: "var(--secondary)",
                          lineHeight: 1.2,
                        }}
                      >

                        <IncrementTransitionWrapper >
                          <IncrementTansition3 className={"text-primary text-semi-bold"} n={s?.value ?? 0} symbol1={``}  symbol2={s?.suffix ?? ""}/>
                        </IncrementTransitionWrapper>
                      </div>
                      <div style={{ fontSize: 11, color: "#999", marginTop: 2 }}>
                        {s.prefix}
                      </div>
                    </div>
                  ))}
                </div>

                <a href='/#about'
                  style={{
                    display: "inline-block",
                    padding: "10px 26px",
                    border: "1.5px solid var(--secondary)",
                    borderRadius: 4,
                    color: "var(--secondary)",
                    fontWeight: 600,
                    fontSize: 13,
                    textDecoration: "none",
                    transition: "0.3s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "var(--secondary)";
                    e.currentTarget.style.color = "var(--light)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "transparent";
                    e.currentTarget.style.color = "var(--secondary)";
                  }}
                  onClick={(e) => {

                    const navbar = document.getElementById('navbarCollapse');
                    if (navbar && navbar.classList.contains('show')) {
                      navbar.classList.remove('show');
                    }

                    if (window.location.pathname === '/') {
                      e.preventDefault();
                      const element = document.getElementById('about');
                      if (element) {
                        const headerOffset = 100; 
                        const elementPosition = element.getBoundingClientRect().top;
                        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                        window.scrollTo({
                          top: offsetPosition,
                          behavior: "smooth"
                        });
                      }
                    }
                  }}
                > Our Story &nbsp;→</a>

              </div>

              <div className="col-12 col-lg-6 wow fadeInRight" data-wow-delay="0.01s">
                <div
                  style={{
                    position: "relative",
                    borderRadius: 18,
                    overflow: "hidden",
                    boxShadow: "0 16px 60px rgba(44,37,23,0.18)",
                    background: "#1a1713",
                    aspectRatio: "16/9",
                    cursor: "pointer",
                  }}
                  onClick={handleVideoClick}
                >
                  <video
                    ref={videoRef}
                    src={videoLink}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                      opacity: videoLoaded ? 1 : 0,
                      transition: "opacity 0.4s",
                    }}
                    playsInline
                    onCanPlay={() => setVideoLoaded(true)}
                    onEnded={() => setIsPlaying(false)}
                  />

                  {!videoLoaded && (
                    <img
                      src={thumbnailLink}
                      alt="Quercus Oak Experience"
                      style={{
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  )}

                  {!isPlaying && (
                    <img
                      src={thumbnailLink}
                      alt="Video Thumbnail"
                      style={{
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        zIndex: 1,
                      }}
                    />
                  )}

                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      background: isPlaying
                        ? "transparent"
                        : "linear-gradient(135deg, rgba(26,23,19,0.45) 0%, rgba(26,23,19,0.1) 100%)",
                      transition: "0.4s",
                      zIndex: 2,
                    }}
                  />
                    {!isPlaying && (
                      <motion.div
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        style={{
                          position: "absolute",
                          top: "40%",
                          left: "42.5%",
                          transform: "translate(-50%, -50%)",
                          width: "clamp(50px, 10vw, 72px)", 
                          height: "clamp(50px, 10vw, 72px)",
                          borderRadius: "50%",
                          background: "rgba(255,255,255,0.92)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 4px 24px rgba(0,0,0,0.25)",
                          zIndex: 3,
                        }}
                      >
                        <i
                          className="bi bi-play-fill"
                          style={{ fontSize: "clamp(20px, 4vw, 28px)", color: "var(--secondary)"}}
                        />
                      </motion.div>
                    )}

                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        padding: "14px 18px",
                        background: "linear-gradient(to top, rgba(26,23,19,0.75), transparent)",
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        zIndex: 4,
                      }}
                    >
                      <img
                        src={require("../assets/img/logolight135x255.png")}
                        alt="Logo"
                        style={{ height: "clamp(20px, 3vw, 28px)", objectFit: "contain" }}
                      />
                      <span
                        style={{
                          color: "rgba(255,255,255,0.85)",
                          fontSize: "clamp(10px, 2vw, 12px)",
                          fontWeight: 500,
                        }}
                      >
                        The Quercus Oak Experience
                      </span>
                    </div>
                  </div>

                <p className="text-muted text-center mt-3" style={{ fontSize: 12.5 }}>
                  <i className="bi bi-volume-up me-1" />
                  Best Experienced with Sound On.
                </p>
              </div>
            </div> 
          </div>
        </div>
        
        {/* Guest Experience End */}
        
        {/* Gallery Start */}
      
        <div className="container-xxl py-5 destination padding-top-custom " style={zoomStyle3} id='gallery'>
          <div className="container">
            <div className="text-center wow fadeInUp" data-wow-delay="0.02s">
              <h6 className="section-title bg-white text-center text-primary px-3">
                Gallery
              </h6>
               <h1 className="mb-2">The Quercus Expericene is more than a Vacation !</h1>
  
            </div>


            <div className="gallery-container2">
              <div className="gallery-wrapper">

                <div className="gallery-main">

                  <img
                    src={propertyImages[currentImageIndex]?.url}
                    alt=""
                  />

                  <div className="gallery-overlay" />

                  <div className="gallery-counter">
                    {currentImageIndex + 1} / {propertyImages.length}
                  </div>

                  {propertyImages?.length > 1 && (
                    <>
                      <button
                        className="gallery-arrow left"
                        onClick={() =>
                          setCurrentImageIndex(
                            (prev) =>
                              (prev - 1 + propertyImages.length) %
                              propertyImages.length
                          )
                        }
                      >
                        <FaChevronLeft />
                      </button>

                      <button
                        className="gallery-arrow right"
                        onClick={() =>
                          setCurrentImageIndex(
                            (prev) =>
                              (prev + 1) % propertyImages.length
                          )
                        }
                      >
                        <FaChevronRight />
                      </button>
                    </>
                  )}
                </div>

                {propertyImages.length > 1 && (
                  <div className="gallery-thumbs-container">
                    <div className="gallery-thumbnails">
                      {propertyImages.map((img, index) => (
                        <div
                          key={index}
                          className={`gallery-thumb ${
                            currentImageIndex === index ? "active" : ""
                          }`}
                          onClick={() => setCurrentImageIndex(index)}
                        >
                          <img src={img?.url} alt="hello" />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>  

        {/* Gallery End */}

        {/* Amenties Start */}
        
        <div className="container-xxl py-5 padding-top-custom padding-bottom-custom" id="amenities">
          <div className="container">
            <div className="text-center wow fadeInUp" data-wow-delay="0.01s">
              <h6 className="section-title bg-white text-center text-primary px-3">
                Amenities
              </h6>
              <h1 className="mb-5">Our Premium Amenties</h1>
            </div>


            {
              !isMobile ?

                <div className="row g-4 wow fadeInUp" data-wow-delay="0.01s">
                  {amenities?.map((item, index) => (
                      <div 
                        className="col-lg-3 col-sm-6" 
                        data-wow-delay={`${index * 0.1}s`} 
                        key={index}
                      >
                        <div className="service-item rounded pt-3 h-100">
                          <div className="p-4 text-center">
                            <div className="text-primary mb-4" style={{ fontSize: '3rem' }}>
                              {amenityIconMap[item.name]}
                            </div>

                            <h5>{item.name}</h5>

                            {item.limited && (
                              <>
                                <span className="badge  text-dark mb-2">Available in Selected Properties Only</span>
                              
                              </>
                            ) }
                          </div>
                        </div>
                      </div>
                    ))}
                </div>

              :

                <div className="wow fadeInUp" data-wow-delay="0.01s">
                  <Swiper
                      modules={[Pagination, Autoplay]}
                      spaceBetween={20}
                      slidesPerView={3}
                      loop={true}
                      pagination={{ clickable: true }}
                      autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                      }}
                      speed={1000}
                      className="h-100" 
                      style={{ height: '100%' }}
                      breakpoints={{
                        0: { slidesPerView: 1 },
                        600: { slidesPerView: 2 },
                        1000: { slidesPerView: 3 },
                      }}
                    >
                    {amenities.map((item,index) => (
                      <SwiperSlide key={`amen-${index}`}>
                        <div 
                          className="col-lg-3 col-sm-6" 
                          data-wow-delay={`${index * 0.1}s`} 
                          key={index}
                          style={{height : '200px'}}
                        >
                          <div className="service-item rounded pt-3">
                            <div className="p-4 text-center">
                              <div className="text-primary mb-4" style={{ fontSize: '3rem' }}>
                                {amenityIconMap[item.name]}
                              </div>

                              <h5>{item.name}</h5>

                              {item.limited && (
                                <>
                                  <span className="badge  text-dark mb-2">Available in Selected Properties Only</span>
                                
                                </>
                              ) }
                            </div>
                          </div>
                        </div>
                        <div style={{ paddingBottom: 40 }}></div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
                  


            }

            
          </div>
        </div>

        {/* Amenties End */}

        {/* Service Start */}
        
        <div className="container-xxl py-5 padding-top-custom padding-bottom-custom wow fadeInUp" data-wow-delay="0.01s" id="services">
          <div className="container">
            <div className="text-center">
              <h6 className="section-title bg-white text-center text-primary px-3">
                Services
              </h6>
              <h1 className="mb-5">Our Services</h1>
            </div>

            <div className="row g-4">

              {/* <div className="col-lg-3 col-sm-6">
                <div className="service-item rounded pt-3">
                  <div className="p-4">
                    <i className="fa fa-3x fa-home text-primary mb-4" />
                    <h5>Property Listing Platform</h5>
                    <p>
                      List Your Villas, Hotels, And Unique Stays With Ease And Reach A Wider Audience Of Verified Travelers.
                    </p>
                  </div>
                </div>
              </div> */}

              <div className="col-lg-4 col-sm-6">
                <div className="service-item rounded pt-3">
                  <div className="p-4">
                    <i className="fa fa-3x fa-search text-primary mb-4" />
                    <h5>Curated Stay Discovery</h5>
                    <p>
                      Explore Handpicked Luxury Villas, Boutique Hotels, And Unique Properties Across Top Destinations.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-sm-6">
                <div className="service-item rounded pt-3">
                  <div className="p-4">
                    <i className="fa fa-3x fa-calendar-check text-primary mb-4" />
                    <h5>Seamless Booking Experience</h5>
                    <p>
                      Enjoy A Smooth And Hassle-Free Booking Process With Transparent Pricing And Instant Confirmations.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-sm-6">
                <div className="service-item rounded pt-3">
                  <div className="p-4">
                    <i className="fa fa-3x fa-star text-primary mb-4" />
                    <h5>Verified Quality Stays</h5>
                    <p>
                      Every Property Is Carefully Reviewed To Ensure High Standards Of Comfort, Cleanliness, And Experience.
                    </p>
                  </div>
                </div>
              </div>
{/* 
              <div className="col-lg-3 col-sm-6">
                <div className="service-item rounded pt-3">
                  <div className="p-4">
                    <i className="fa fa-3x fa-chart-line text-primary mb-4" />
                    <h5>Revenue Growth For Hosts</h5>
                    <p>
                      Maximize Your Property’s Earnings With Better Visibility, Smart Pricing, And Targeted Promotions.
                    </p>
                  </div>
                </div>
              </div> */}

              <div className="col-lg-4 col-sm-6">
                <div className="service-item rounded pt-3">
                  <div className="p-4">
                    <i className="fa fa-3x fa-users text-primary mb-4" />
                    <h5>Guest & Host Support</h5>
                    <p>
                      Dedicated Support To Assist Both Travelers And Property Owners At Every Step Of The Journey.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-sm-6">
                <div className="service-item rounded pt-3">
                  <div className="p-4">
                    <i className="fa fa-3x fa-map-marker-alt text-primary mb-4" />
                    <h5>Multiple Destinations</h5>
                    <p>
                      Access Premium Stays Across Popular Travel Locations And Hidden Gems For Every Kind Of Traveler.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-sm-6">
                <div className="service-item rounded pt-3">
                  <div className="p-4">
                    <i className="fa fa-3x fa-heart text-primary mb-4" />
                    <h5>Personalized Experiences</h5>
                    <p>
                      Discover Stays And Experiences Tailored To Your Preferences — From Romantic Getaways To Family Vacations.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div> 

        {/* Service End */}

        {/* Why Us Start */}

        <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.01s">
          <div className="container">
            <div className="text-center pb-4">
              <h6 className="section-title bg-white text-center text-primary px-3">
                Why Us
              </h6>
              <h1 className="mb-5">Why Choose Quercus Oak Stay</h1>
            </div>

            <div className="row gy-5 gx-4 justify-content-center">

              <div className="col-lg-4 col-sm-6 text-center pt-4">
                <div className="position-relative border border-primary pt-5 pb-4 px-4" style={{ height: '270px' }}>
                  <div
                    className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                    style={{ width: 100, height: 100 }}
                  >
                    <i className="fa fa-home fa-3x text-white" />
                  </div>
                  <h5 className="mt-4">Curated Premium Stays</h5>
                  <hr className="w-25 mx-auto bg-primary mb-1" />
                  <hr className="w-50 mx-auto bg-primary mt-0" />
                  <p className="mb-0">
                    Discover handpicked villas, hotels, and unique properties that meet our quality standards for comfort, design, and experience.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-sm-6 text-center pt-4">
                <div className="position-relative border border-primary pt-5 pb-4 px-4" style={{ height: '270px' }}>
                  <div
                    className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                    style={{ width: 100, height: 100 }}
                  >
                    <i className="fa fa-globe fa-3x text-white" />
                  </div>
                  <h5 className="mt-4">Wide Range Of Destinations</h5>
                  <hr className="w-25 mx-auto bg-primary mb-1" />
                  <hr className="w-50 mx-auto bg-primary mt-0" />
                  <p className="mb-0">
                    From serene hill stations to vibrant tourist hubs, explore stays across top destinations tailored to every travel style.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-sm-6 text-center pt-4">
                <div className="position-relative border border-primary pt-5 pb-4 px-4" style={{ height: '270px' }}>
                  <div
                    className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                    style={{ width: 100, height: 100 }}
                  >
                    <i className="fa fa-star fa-3x text-white" />
                  </div>
                  <h5 className="mt-4">Trusted By Guests & Hosts</h5>
                  <hr className="w-25 mx-auto bg-primary mb-1" />
                  <hr className="w-50 mx-auto bg-primary mt-0" />
                  <p className="mb-0">
                    Loved by travelers and trusted by property owners, we ensure reliable bookings, verified listings, and quality experiences.
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Why Us End */}

        {/* Testimonial Starts */}

        <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.01s" id="guest-testimonials">
          <div className="container">
            <div className="text-center">
              <h6 className="section-title bg-white text-center text-primary px-3">
                Guest Testimonials
              </h6>
              <h1 className="mb-5">Our Clients Say!!!</h1>
            </div>

            <div className="testimonial-carousel-wrapper">

              {testimonials.length > 0 && (
                <Swiper
                  modules={[Pagination, Autoplay]}
                  spaceBetween={20}
                  slidesPerView={3}
                  loop={true}
                  pagination={{ clickable: true }}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                  speed={1000}
                  breakpoints={{
                    0: { slidesPerView: 1, spaceBetween: 0 },   
                    600: { slidesPerView: 2, spaceBetween: 10 },
                    1000: { slidesPerView: 3, spaceBetween: 20 },
                  }}
                >
                {testimonials.map((t,index) => (
                  <SwiperSlide key={`loc-${index}`}>

                      <div key={`${t._id}-${index}`} className="item" style={{ paddingTop: 40 }}>
                        <div
                          style={{
                            background: "#f7f5f2",
                            borderRadius: 14,
                            padding: "0 22px 24px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            textAlign: "center",
                            position: "relative",
                            minHeight: "250px"
                          }}
                        >
                          <div style={{ position: "absolute", top: -40 }}>
                            <img
                              src={t.avatar}
                              alt={t.name}
                              style={{
                                width: 80,
                                height: 80,
                                borderRadius: "50%",
                                objectFit: "cover",
                                border: "3px solid #fff",
                                boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
                              }}
                            />
                          </div>

                          <div style={{ height: 56 }} />


                          <div style={{ display: "flex", gap: "2px", marginBottom: 10 }}>
                            {[1, 2, 3, 4, 5].map((starIndex) => {
                              const fillValue = Math.max(0, Math.min(1, t.rating - (starIndex - 1)));
                              const fillPercent = fillValue * 100;

                              return (
                                <svg
                                  key={starIndex}
                                  viewBox="0 0 24 24"
                                  style={{ width: "18px", height: "18px" }}
                                >
                                  <defs>
                                    <linearGradient id={`grad-${t._id}-${starIndex}`}>
                                      <stop offset={`${fillPercent}%`} stopColor="#FFD700" />
                                      <stop offset={`${fillPercent}%`} stopColor="#ccc" />
                                    </linearGradient>
                                  </defs>
                                  <path
                                    fill={`url(#grad-${t._id}-${starIndex})`}
                                    d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
                                  />
                                </svg>
                              );
                            })}
                            <span style={{ fontSize: "14px", marginLeft: "5px", fontWeight: "bold", color: "#555" }}>
                              {/* {t.rating} */}
                            </span>
                          </div>

                          <p style={{ fontSize: 13.5, color: "#555", lineHeight: 1.8, marginBottom: 14 }}>
                            {t.text?.substring(0, 145)}...{" "}
                            <span 
                              onClick={() => openModal(t)} 
                              style={{ color: "var(--primary)", fontWeight: 600, cursor: "pointer" }}>
                              Read More
                            </span>
                          </p>

                          <div style={{ fontWeight: 700, fontSize: 14, color: "var(--primary)", marginBottom: 2 }}>
                            {t.name}
                          </div>
                          <div style={{ fontSize: 11, color: "var(--primary)", opacity: 0.8 }}>
                            {t.propertyId?.title || t.property}
                          </div>
                        </div>
                      </div>

                    <div style={{ paddingBottom: 40 }}></div>
                  </SwiperSlide>
                ))}
                </Swiper>
              )}
            </div>
          </div>
        </div> 

        {/* Testimonial Ends */}

        {/* Banner Starts */}

        <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.01s">
          <div className="container">
            <div className="demo p-5">
              <div className="row g-5 align-items-center text-center">

                <div className="col-lg-3 col-md-6 col-sm-6 col-6 position-relative mx-auto">
                  <img
                    className="img-fluid custom-Genie"
                    src={require('../assets/img/logolight135x255.png')}
                    alt="Quercus Oak Stay"
                    style={{ objectFit: "cover" }}
                  />
                </div>

                <div className="col-lg-9 col-md-6 text-white">

                  <div>
                    <span className="btn btn-sm px-3 border-end custom-demoButton">
                      List Your Property Today
                    </span>
                  </div>

                  <br />

                  <h1 className="custom-text mb-4">
                    Turn Your Property Into A High-Earning Stay
                  </h1>

                  <p className="custom-text mb-4 custom-text-bold">
                    Join Quercus Oak Stay And Showcase Your Villas, Hotels, Apartments, Or Unique Properties To A Growing Network Of Travelers Across Premium Destinations.
                  </p>

                  <p className="custom-text mb-4 custom-text-bold">
                    We Help You Maximize Bookings, Manage Guests Seamlessly, And Deliver Exceptional Stay Experiences With Our Dedicated Support.
                  </p>

                  <div>
                    <a
                      href={'/list-property'}
                      className="btn btn-sm px-3 border-end custom-demoButton mb-2"
                    >
                      List Your Property
                    </a>
                  
                  
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div> 

        {/* Banner End */}

        {/* FAQ Starts */}

        <div className="container-xxl py-5 wow fadeInUp" id="faq" data-wow-delay="0.02s" >
          <div className="container">
            <div className="text-center">
              <h6 className="section-title bg-white text-center text-primary px-3">
                FAQ'S
              </h6>
              <h1 className="mb-5">Frequently Asked Questions!!!</h1>
              <div className="row g-1 align-items-center">
                <div className='col-md-12'>
                  <FAQS/>
                </div>
              </div>
            </div>
          </div>
        </div> 

        {/* FAQ END */}

        {/* Query Start */}

        <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.02s" id='contactus'>
            <div className="container">
              <div className="booking p-5">
                <div className="row g-5 align-items-center">
                  <div className="col-md-6 text-white">
                    
                    <h1 className="text-white mb-4">Ask Out Your Question</h1>
                    <p className="mb-4">
                      We're here to help! Whether you have questions about our Properties, need Assistance with a Booking, or just want more information about how Quercus Oak Stays works, feel free to reach out.
                    </p>
                    <p className="mb-4">
                  Our Team is ready to provide you with all the support you need to make your Stay at Quercus Oak a truly Seamless and Memorable Experience.
                    </p>
        
                  </div>
                  <div className="col-md-6" >
                    <h1 className="text-white mb-4">Queries</h1>
                    <form>
                      <div className="row g-3">
                        <div className="col-md-6">
                          <div className="form-floating">

                            <input 
                              type="text" 
                              id="name"
                              className="form-control text-white bg-transparent"
                              value={name} 
                              placeholder="Your Good Name"
                              required 
                              onChange={(e)=>setName(e.target.value)}
                            />
                            <label className="text-white" htmlFor="name">Your Good Name</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-floating">
                          <input 
                              type="text" 
                              id ="email"
                              className="form-control text-white bg-transparent" 
                              value={email} 
                              placeholder="Where can we Contact you?" 
                              required 
                              onChange={(e)=>setEmail(e.target.value)}
                            />
                            <label className="text-white"  htmlFor="email">Your Email</label>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-floating">
                          <input 
                              type="text" 
                              className="form-control text-white bg-transparent" 
                              id ="phone" 
                              value={phone} 
                              placeholder="Your Contact Number" 
                              onChange={(e)=>setPhone(e.target.value)}
                            />
                            <label className="text-white" htmlFor="email">Your Phone Number</label>
                          </div>
                        </div>
                
                        <div className="col-12">
                          <div className="form-floating">
                            <textarea
                              className="form-control text-white bg-transparent"
                              placeholder="We would love to hear and answer all your Questions"
                              // id="message"
                              required
                              style={{ height: 100 }}
                              value={query} 
                              onChange={(e)=>setQuery(e.target.value)}
                            />
                            <label className="text-white" htmlFor="message">We would love to hear and answer all your Questions</label>
                          </div>
                        </div>
                        <div className="col-12">
                          <button
                            className="btn btn-outline-light w-100 py-3"
                            type="submit"
                            onClick={(e)=>handleSubmit(e)}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
        </div> */

        {/* Query End */}
      
        {isModalOpen && selectedTestimonial && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button onClick={closeModal} className="close-btn">&times;</button>
              
              <div style={{ textAlign: "center" }}>
                <img 
                  src={selectedTestimonial.avatar} 
                  alt={selectedTestimonial.name} 
                  style={{ width: 100, height: 100, borderRadius: "50%", marginBottom: 15, border: "3px solid var(--primary)" }}
                />
                <h4 style={{ color: "var(--primary)", marginBottom: 5 }}>{selectedTestimonial.name}</h4>
                <p style={{ fontSize: 13, color: "#888", marginBottom: 20 }}>{selectedTestimonial.property}</p>
                
                <p style={{ fontSize: 15, color: "#444", lineHeight: 1.8, textAlign: "left" }}>
                  {selectedTestimonial.text} 
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  )
}
